import React, { useEffect, useState } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import MiniButton from './miniButton';
import { fontFamily } from '../../helpers/fontFamily';
import { useRoute } from '@react-navigation/native';
import { useDispatch } from 'react-redux';
import { checkPushPermissions } from '../../actions/inventoryReportActions';

const inventoryReportTable = ({ report, onExport, onView, onDelete, onArchive, onRestore, onResume, mode, onViewAndPush }) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768; // Common breakpoint for mobile devices
  const [pushPermissions, setPushPermissions] = useState({ can_push: false, has_mixed_stores: false });
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPushPermissions = async () => {
      try {
        const permissions = await dispatch(checkPushPermissions(report.id));
        setPushPermissions(permissions);
      } catch (error) {
        setPushPermissions({ can_push: false, has_mixed_stores: false });
      }
    };

    if (report.status === 'received') {
      fetchPushPermissions();
    }
  }, [report.id, report.status, dispatch]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <View style={{
      marginVertical: 10,
      padding: 15,
      borderRadius: 12,
      width: '100%',
      maxWidth: 800,
      alignSelf: 'center',
      margin: 'auto'
    }}>
      <View style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 4,
        flexWrap: 'nowrap',
        justifyContent: isMobile ? 'center' : 'space-between'
      }}>
        <View style={{
          flexDirection: 'row',
          alignItems: 'center',
          flex: 1,
          justifyContent: isMobile ? 'center' : 'flex-start'
        }}>
          <Text style={{
            color: '#ffffff',
            fontSize: 16,
            fontFamily: fontFamily.font300,
            marginRight: 10,
            flexShrink: 1,
            textAlign: isMobile ? 'center' : 'left'
          }}>
            {report.name}
          </Text>
          <Text style={{
            color: '#ccc',
            fontSize: 13,
            flexShrink: 0,
            textAlign: isMobile ? 'center' : 'left'
          }}>
            Edited: {report.updated_at ? formatDate(report.updated_at) : 'N/A'}
          </Text>
        </View>
      </View>

      <View style={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 10,
        justifyContent: isMobile ? 'center' : 'center',
        gap: 6
      }}>
        <MiniButton label="Export" onPress={() => onExport(report.id)} />
        {pushPermissions.can_push && report.status === 'received' && report.push_status === 'pending' ? (
          <MiniButton label="View & Push" onPress={() => onViewAndPush(report)} />
        ) : (
          <MiniButton label="View" onPress={() => onView(report)} />
        )}

        {(report.status !== 'received' || report.archived) && (
          <MiniButton label="Delete" onPress={() => onDelete(report.id)} />
        )}

        {!report.archived && report.status === 'received' && (
          <MiniButton label="Archive" onPress={() => onArchive(report.id)} />
        )}

        {report.archived && (
          <MiniButton label="Restore" onPress={() => onRestore(report.id)} type="highlight" />
        )}

        {!report.archived && (
          report.status === 'received' ? (
            (() => {
              const receivedLabel = mode === 'receive' ? 'Received' : 'Recounted';
              if (pushPermissions.can_push) {
                if (report.push_status === 'pushed') {
                  return <MiniButton label={`${receivedLabel} & Pushed`} disabled />;
                } else {
                  return <MiniButton label={receivedLabel} disabled />;
                }
              } else {
                return <MiniButton label={receivedLabel} disabled />;
              }
            })()
          ) : (
            <MiniButton label="Resume" onPress={() => onResume(report, mode)} type="highlight" />
          )
        )}
      </View>
    </View>
  );
};

export default inventoryReportTable;
